(function(angular) {
    'use strict';
    class ProtectEditedOutreach {
        constructor($translate, $mdDialog) {
            this.$translate = $translate;
            this.$mdDialog = $mdDialog;
        }

        $onInit() {
            this.modalTitle = this.$translate.instant('icm-outreach__protect-edited--modal-title');
            this.okText = this.$translate.instant('action-label__save');
            this.cancelText = this.$translate.instant('action-label__cancel');
            this.content = this.$translate.instant('icm-outreach__protect-edited--modal-content');
            this.optionCopy = this.$translate.instant('icm-outreach__protect-edited--option-copy');
            this.optionOverwrite = this.$translate.instant('icm-outreach__protect-edited--option-overwrite');
            this.selectedOption = 'copy';
            this.subject = this.$translate.instant('mw-outreach-collection__column-header-subject');
            this.subjectDefault = this.$translate.instant('icm-outreach__protect-edited--subject-placeholder', {subject: this.distribution.subject});
        }

        handleOk () {
            var data = {
                option: this.selectedOption,
                subject: this.subjectDefault
            };
            this.$mdDialog.hide(data);
        }

        handleCancel() {
            this.$mdDialog.cancel();
        }
    }

    angular.module('MW.ContactManager.ProtectEditedOutreach', [
        'ngMaterial'
    ])
    .component('protectEditedOutreach', {
        bindings: {
            distribution: '<',
            disallowOverwrite: '<'
        },
        controller: ['$translate', '$mdDialog', ProtectEditedOutreach],
        template: `
        <mw-mini-modal-dialog layout="column" data="$ctrl.distribution" dialog-title="{{$ctrl.modalTitle}}" ok="{{$ctrl.okText}}" cancel="{{$ctrl.cancelText}}" on-ok="$ctrl.handleOk($event)" on-cancel="$ctrl.handleCancel($event)">
            <mw-modal-content>
                <div layout="column">
                    <p>
                    {{$ctrl.content}}
                    </p>
                    <div layout="column">
                        <md-radio-group class="md-primary" ng-model="$ctrl.selectedOption">
                            <md-radio-button value="copy">{{$ctrl.optionCopy}}</md-radio-button>
                            <md-input-container flex>
                                <input name="subject" ng-model="$ctrl.subjectDefault" required />
                            </md-input-container>
                            <md-radio-button ng-disabled="$ctrl.disallowOverwrite==true" value="overwrite">{{$ctrl.optionOverwrite}}</md-radio-button>
                        </md-radio-group>
                    </div>
                </div>
            </mw-modal-content>
        </mw-mini-modal-dialog>
        `
    });
})(window.angular);
